export default __webpack_public_path__ + "static/media/loopGreen.b473e349.svg";